import React, { useEffect, useState } from "react";
import { Row, Col, Image, Button } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import Card from "../../../components/Card";

// img
import shap1 from "../../../assets/images/shapes/01.png";
import shap2 from "../../../assets/images/shapes/02.png";
import shap3 from "../../../assets/images/shapes/03.png";
import shap4 from "../../../assets/images/shapes/04.png";
import shap5 from "../../../assets/images/shapes/05.png";
import shap6 from "../../../assets/images/shapes/06.png";
import { getAllUsers, getStatistics } from "../../../helpers/auth";
import {
  deleteCategory,
  getAllMainCategories,
  getAllSubCategories,
  updateCategory,
} from "../../../helpers/category";

import Container from "react-bootstrap/Container";

import { useHistory } from "react-router-dom";

// const categories = [
//   {
//     img: `${shap1}`,
//     name: "Anna Sthesia",
//     phone: "(760) 756 7568",
//     email: "annasthesia@gmail.com",
//     country: "USA",
//     status: "Active",
//     company: "Acme Corporation",
//     joindate: "2019/12/01",
//     color: "bg-primary",
//   },
// {
//     img: `${shap2}`,
//     name: "Brock Lee",
//     phone: "+62 5689 458 658",
//     email: "brocklee@gmail.com",
//     country: "Indonesia",
//     status: "Active",
//     company: "Soylent Corp",
//     joindate: "2019/12/01",
//     color: "bg-primary",
//   },
//   {
//     img: `${shap3}`,
//     name: "Dan Druff",
//     phone: "+55 6523 456 856",
//     email: "dandruff@gmail.com",
//     country: "Brazil",
//     status: "Pending",
//     company: "Acme Corporation",
//     joindate: "2019/12/01",
//     color: "bg-warning",
//   },
//   {
//     img: `${shap4}`,
//     name: "Hans Olo",
//     phone: "+91 2586 253 125",
//     email: "hansolo@gmail.com",
//     country: "India",
//     status: "Inactive",
//     company: "Vehement Capital",
//     joindate: "2019/12/01",
//     color: "bg-danger",
//   },
//   {
//     img: `${shap5}`,
//     name: "Lynn Guini",
//     phone: "+27 2563 456 589",
//     email: "lynnguini@gmail.com",
//     country: "Africa",
//     status: "Active",
//     company: "Massive Dynamic",
//     joindate: "2019/12/01",
//     color: "bg-primary",
//   },
//   {
//     img: `${shap6}`,
//     name: "Eric Shun",
//     phone: "+55 25685 256 589",
//     email: "ericshun@gmail.com",
//     country: "Brazil",
//     status: "Pending",
//     company: "Globex Corporation",
//     joindate: "2019/12/01",
//     color: "bg-warning",
//   },
//   {
//     img: `${shap3}`,
//     name: "aaronottix",
//     phone: "(760) 756 7568",
//     email: "budwiser@ymail.com",
//     country: "USA",
//     status: "Hold",
//     company: "Acme Corporation",
//     joindate: "2019/12/01",
//     color: "bg-info",
//   },
//   {
//     img: `${shap5}`,
//     name: "Marge Arita",
//     phone: "+27 5625 456 589",
//     email: "margearita@gmail.com",
//     country: "Africa",
//     status: "Complite",
//     company: "Vehement Capital",
//     joindate: "2019/12/01",
//     color: "bg-success",
//   },
//   {
//     img: `${shap2}`,
//     name: "Bill Dabear",
//     phone: "+55 2563 456 589",
//     email: "billdabear@gmail.com",
//     country: "Brazil",
//     status: "Active",
//     company: "Massive Dynamic",
//     joindate: "2019/12/01",
//     color: "bg-primary",
//   },
// ];

const CategoryList = () => {
  const [categories, setCategories] = useState([]);
  const [name, setName] = useState();

  const { id } = useParams();

  const location = useHistory();

  //   const { name } = useSearchParam();

  const ApiCall = async (id) => {
    if (!id) {
      let data = await getAllMainCategories();
      setCategories(data);
    } else {
      let data = await getAllSubCategories(id);
      setCategories(data);
    }
  };

  async function deleteCategoryHandler(id) {
    const response = await deleteCategory(id);
    console.log(response, "response");
  }

  async function updateCategoryHandler(item) {
    const response = await updateCategory(item._id, { name: name });
    console.log(response, "response update");
  }

  useEffect(() => {
    if (id) {
      ApiCall(id);
    } else {
      ApiCall();
    }
  }, [id]);

  console.log(name, "setName");

  return (
    <>
      <div>
        <Row>
          <Col sm="12">
            <Card>
              <Card.Header className="d-flex justify-content-between">
                <div className="header-title">
                  <Container>
                    <Row>
                      <Col>
                        {" "}
                        <h4 className="card-title">
                          {id
                            ? `${`Sub Category List `}`
                            : "Main Category List"}
                        </h4>
                      </Col>
                      <Col>
                        {" "}
                        <Button
                          type="button"
                          variant="btn btn-primary"
                          onClick={() => {
                            if (id) {
                              location.push(
                                `/dashboard/app/category-add/${id}`
                              );
                            } else {
                              location.push(`/dashboard/app/category-add`);
                            }
                          }}
                        >
                          Add Category
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </div>
              </Card.Header>
              <Card.Body className="px-0">
                <div className="table-responsive">
                  <table
                    id="user-list-table"
                    className="table table-striped"
                    role="grid"
                    data-toggle="data-table"
                  >
                    <thead>
                      <tr className="ligth">
                        <th>Image</th>
                        <th>Name</th>
                        {id && <th>Parent Category </th>}
                        {/* <th>Created At</th> */}
                        <th min-width="100px">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {categories.map((item, idx) => (
                        <tr key={idx}>
                          <td className="text-center">
                            <Image
                              className="bg-soft-primary rounded img-fluid avatar-40 me-3"
                              src={item?.image?.url}
                              alt={item.name}
                            />
                          </td>
                          <td>
                            <a href={`/dashboard/app/category/${item._id}`}>
                              {item.name}
                            </a>
                          </td>
                          {/* <td>{item.phone}</td> */}
                          {/* <td>{item.email}</td>
                          <td>{item.role}</td>
                          <td>
                            <span
                              className={`badge ${item.isVerified ? "bg-success" : "bg-danger"}`}
                            >
                              {item.isVerified ? "Verified" : "Not Verified"}
                            </span>
                          </td> */}
                          {/* <td>{item.company}</td> */}
                          {id && <td>{item?.parentCategory?.name}</td>}
                          <td className="flex items-center justify-between">
                            <input
                              onChange={(e) => setName(e.target.value)}
                              type="text"
                            />
                            <button
                              className="bg-black text-white rounded-md "
                              onClick={() => updateCategoryHandler(item)}
                            >
                              Edit
                            </button>
                          </td>
                          <td>
                            <div className="flex align-items-center list-user-action">
                              <Link
                                className="btn btn-sm btn-icon btn-danger"
                                data-toggle="tooltip"
                                data-placement="top"
                                title=""
                                data-original-title="Delete"
                                to="#"
                              >
                                <span
                                  className="btn-inner"
                                  onClick={() =>
                                    deleteCategoryHandler(item._id)
                                  }
                                >
                                  {/* xzcxx */}
                                  <svg
                                    width="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    stroke="currentColor"
                                  >
                                    <path
                                      d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826"
                                      stroke="currentColor"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>
                                    <path
                                      d="M20.708 6.23975H3.75"
                                      stroke="currentColor"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>
                                    <path
                                      d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973"
                                      stroke="currentColor"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>
                                  </svg>
                                </span>
                              </Link>{" "}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default CategoryList;
